// extracted by mini-css-extract-plugin
export default {"button":"TMB4Tn7Y","buttonCustomColor":"CGaFAYlI","smalSize":"u3HhEJw5","disabled":"gaXdJF_E"};